module.exports = {
  "zones": {
    "Atlantic/Faeroe": ["z", {
      "wallclock": 347155200000,
      "format": "WE%sT",
      "abbrev": "WET",
      "offset": 0,
      "posix": 347155200000,
      "save": 0,
      "rules": "EU"
    }, {
      "wallclock": -1955750400000,
      "format": "WET",
      "abbrev": "WET",
      "offset": 0,
      "posix": -1955748776000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": -1624000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {
    "EU": [{
      "from": 1981,
      "to": 1.7976931348623157e+308,
      "month": 2,
      "day": [0, -31],
      "time": 60,
      "clock": "posix",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1996,
      "to": 1.7976931348623157e+308,
      "month": 9,
      "day": [0, -31],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1985,
      "to": 1995,
      "month": 8,
      "day": [0, -30],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1984,
      "to": 1984,
      "month": 8,
      "day": [0, -30],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1982,
      "to": 1983,
      "month": 8,
      "day": [0, -30],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1981,
      "to": 1981,
      "month": 8,
      "day": [0, -30],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1977,
      "to": 1980,
      "month": 3,
      "day": [0, 1],
      "time": 60,
      "clock": "posix",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1979,
      "to": 1980,
      "month": 8,
      "day": [0, -30],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1978,
      "to": 1978,
      "month": 9,
      "day": [7, 1],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1977,
      "to": 1977,
      "month": 8,
      "day": [0, -30],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }]
  }
};